import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { OrientationFilter } from "~/components/Filters/OrientationFilter/OrientationFilter";
import { SingleFilterContainer } from "~/components/Filters/SingleFilters/SingleFilterContainer";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { clearStringArrayFilterValuesAction, setStringArrayFilterValuesAction } from "~/store/filters/actions";
import { selectedStringArrayFiltersSelector } from "~/store/filters/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
export const SingleOrientationFilter = /*#__PURE__*/ memo((param)=>{
    let { onApplyClick } = param;
    const dispatch = useDispatch();
    const { searchImprovements } = useTemporaryFeatureFlags();
    const selectedOrientations = useAirSelector((st)=>selectedStringArrayFiltersSelector(st, "orientations"));
    const hasValues = selectedOrientations.length > 0;
    const clearValues = useCallback(()=>{
        dispatch(clearStringArrayFilterValuesAction({
            filter: "orientations"
        }));
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        dispatch,
        searchImprovements,
        onApplyClick
    ]);
    const onSelectionChange = useCallback((values)=>{
        dispatch(setStringArrayFilterValuesAction({
            values,
            filter: "orientations"
        }));
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        dispatch,
        onApplyClick,
        searchImprovements
    ]);
    return /*#__PURE__*/ _jsx(SingleFilterContainer, {
        hasValues: hasValues,
        currentFilter: "orientation",
        onClearClick: clearValues,
        onApplyClick: onApplyClick,
        children: /*#__PURE__*/ _jsx(OrientationFilter, {
            selectedValues: selectedOrientations,
            onSelectionChange: onSelectionChange
        })
    });
});
SingleOrientationFilter.displayName = "SingleOrientationFilter";
